import { PageTitle } from '@okam/brand-ui/index'
import { isHex } from '@okam/core-lib/index'
import { useHtml2React } from '@okam/html2react/provider'
import { css } from 'twin.macro'
import { MainLayout } from 'components/layout'
import type { TDirectusProps } from 'components/layout/MainLayout'
import ProductsListing from 'components/products-listing/ProductsListing'
import Seo from 'components/Seo'
import type { SeoContentFragment } from 'gql/graphql'
import { QueryKeys, useProductsArchivePage } from 'lib/react-query'
import { useColor } from 'providers/Color'

export interface TProductsArchivePage {
  locale: string
  seo: { seo: SeoContentFragment | null | undefined; pageTitle: string }
  directusProps: TDirectusProps
}

const ProductsArchivePage = ({ locale, seo, directusProps }: TProductsArchivePage) => {
  const { setColorScheme } = useColor()

  const { data: pageData, isSuccess: pageSuccess } = useProductsArchivePage(
    QueryKeys.GetProductsArchivePage,
    locale,
    (animalArchiveColorScheme) => {
      setColorScheme({
        title: animalArchiveColorScheme?.title || 'Test',
        accent: isHex(animalArchiveColorScheme?.accent) ? animalArchiveColorScheme?.accent ?? '#000000' : '#000000',
        background: isHex(animalArchiveColorScheme?.background)
          ? animalArchiveColorScheme?.background ?? '#000000'
          : '#000000',
      })
    },
  )

  const backgroundColor = pageData?.colorScheme?.background
  const logoColor = pageData?.colorScheme?.accent

  const { parseHTMLToReact } = useHtml2React()

  return (
    <>
      <Seo directusData={directusProps} seo={seo?.seo} pageTitle={seo?.pageTitle} />
      <MainLayout footerProps={directusProps} logoColor={logoColor}>
        {pageSuccess && (
          <>
            <PageTitle
              css={css`
                background-color: ${backgroundColor};
              `}
            >
              {parseHTMLToReact(pageData?.translations?.[0]?.title ?? '')}
            </PageTitle>
            <ProductsListing queryKey={QueryKeys.GetProductsListing} locale={locale} />
          </>
        )}
      </MainLayout>
    </>
  )
}
export default ProductsArchivePage
